import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import { parseBoldText } from "@/util/parseBoldText";

import { trpc } from "@/util/trpc";
import { inAppToastNotificationSchema } from "@talentir/shared/in-app-noitifcation-schema";
import Pusher from "pusher-js";
import { useEffect } from "react";
import { toast } from "sonner";

const pusher = new Pusher("62a641659287b9a439af", {
    cluster: "eu",
});

export function useToastNotification() {
    const { user: userProfile } = useGetLoggedInUser();
    const utils = trpc.useUtils();

    useEffect(() => {
        if (userProfile == null) return;

        const channel = pusher.subscribe(`notification-${userProfile.id}`);
        channel.bind("notification", (data: unknown) => {
            const result = inAppToastNotificationSchema.parse(data);

            // toast(result.title, { description: result.content });

            toast(result.title, { description: parseBoldText(result.content) });

            // when user receives a notification, invalidate all queries
            void utils.invalidate();
        });

        return () => {
            channel.unbind("notification");
            channel.unsubscribe();
        };
    }, [userProfile, utils]);
}
